var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSalvar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "salvar",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.136,
    height: 16.667,
    viewBox: "0 0 16.136 16.667",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_88",
    "data-name": "Grupo 88",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_162",
    "data-name": "Caminho 162",
    d: "M19.695,0H7.72a.639.639,0,0,0-.637.637V16.03a.639.639,0,0,0,.637.637H22.582a.639.639,0,0,0,.637-.637V4.342a.612.612,0,0,0-.138-.393L20.194.244A.65.65,0,0,0,19.695,0ZM11.966,1.274h6.688V7.537H11.966Zm9.979,14.119H8.357V1.274h2.335V8.185a.586.586,0,0,0,.584.626h8.047a.6.6,0,0,0,.605-.626V2.017l2.017,2.548V15.393Z",
    transform: "translate(-7.083)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_163",
    "data-name": "Caminho 163",
    d: "M224.434,65.8a.639.639,0,0,0-.637-.637h-.743a.639.639,0,0,0-.637.637v2.548a.639.639,0,0,0,.637.637h.743a.639.639,0,0,0,.637-.637Z",
    transform: "translate(-214.349 -62.725)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalvar);
export default __webpack_public_path__ + "static/media/salvar.56d58f80ababc304425d01de8157a521.svg";
export { ForwardRef as ReactComponent };